document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth < 769) {
    // スマートフォン用の処理
    var h = window.innerHeight;
    document.querySelectorAll(".hero-slide, .hero-slide-wrapper").forEach(function(el) {
      el.style.height = (h) + "px";
    });
  } else {
    // PC用の処理（何も書かれていないため空の状態）
  }

  var MAX_PICK = 5;
  var DID_RUN = false;

  function shuffleArray(arr){
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function setHeroTitleOpacity(val){
    document.documentElement.style.setProperty("--heroTitleOpacity", String(val));
  }

  function bindHideTitle($slider, flkty){
    // 最初は表示
    setHeroTitleOpacity(1);

    function hide(){
      setHeroTitleOpacity(0);
    }

    function hideIfMoved(){
      var idx = (typeof flkty.selectedIndex === "number") ? flkty.selectedIndex : 0;
      if (idx !== 0) hide();
    }

    // Flickityイベント（確実に拾える組）
    flkty.off("select.__hideTitle");
    flkty.off("dragStart.__hideTitle");
    flkty.off("pointerUp.__hideTitle");
    flkty.off("settle.__hideTitle");

    flkty.on("select.__hideTitle", hideIfMoved);
    flkty.on("settle.__hideTitle", hideIfMoved);
    flkty.on("dragStart.__hideTitle", hide);
    flkty.on("pointerUp.__hideTitle", hideIfMoved);

    // UI操作の保険（矢印/ドット/リンク等）
    $slider.off("click.__hideTitle").on("click.__hideTitle", function(){
      setTimeout(hideIfMoved, 0);
    });

    // タッチ/マウス/ホイールの保険（「触ったら消す」運用）
    $slider.off("pointerdown.__hideTitle").on("pointerdown.__hideTitle", hide);
    $slider.off("touchstart.__hideTitle").on("touchstart.__hideTitle", hide);
    $slider.off("wheel.__hideTitle").on("wheel.__hideTitle", hide);

    // キーボードの保険
    $(document).off("keydown.__hideTitle").on("keydown.__hideTitle", function(e){
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        setTimeout(hideIfMoved, 0);
      }
    });
  }

  function run(){
    if (DID_RUN) return;

    var $slider = $(".slideshow__slide_container.flickity-enabled").first();
    if (!$slider.length) return;

    var flkty = null;

    if ($slider.data("flickity")) {
      flkty = $slider.data("flickity");
    } else if (window.Flickity && typeof window.Flickity.data === "function") {
      flkty = window.Flickity.data($slider.get(0));
    }

    if (!flkty) return;

    var cellEls = (typeof flkty.getCellElements === "function") ? flkty.getCellElements() : [];
    if (!cellEls || !cellEls.length) return;

    DID_RUN = true;

    // -----------------------------
    // 5枚抽選 → それ以外を削除
    // -----------------------------
    var arr = cellEls.slice();
    shuffleArray(arr);

    var pickCount = Math.min(MAX_PICK, arr.length);
    var picked = arr.slice(0, pickCount);

    var removeEls = [];
    for (var i = 0; i < arr.length; i++) {
      if (picked.indexOf(arr[i]) === -1) removeEls.push(arr[i]);
    }

    if (removeEls.length) {
      flkty.remove(removeEls);
    }

    flkty.reloadCells();
    flkty.resize();
    flkty.select(0, false, true);

    $slider.attr("data-slide-count", pickCount);

    // -----------------------------
    // スライドしたら文字を消す
    // -----------------------------
    bindHideTitle($slider, flkty);
  }

  var start = Date.now();
  var timer = setInterval(function(){
    run();
    if (DID_RUN || (Date.now() - start) > 2000) {
      clearInterval(timer);
    }
  }, 50);

});